import { render } from "./TileOptions.vue?vue&type=template&id=05f662c8&lang=pug"
import script from "./TileOptions.vue?vue&type=script&lang=js"
export * from "./TileOptions.vue?vue&type=script&lang=js"

import "./TileOptions.vue?vue&type=style&index=0&id=05f662c8&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__